import axios from "axios";
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../serviceUrls";

export const getFaqArticleFilterRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_FAQ_ARTICLE_FILTER_API,
    params: params,
  });
};
export const getFaqArticleListRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_FAQ_ARTICLE_LIST_API,
    params: params,
  });
};

export const getFaqQuestionKeywordsRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_FAQ_QUESTION_KEYWORDS_API,
    params: params,
  });
};

export const getFaqEditPageCommonRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_FAQ_EDIT_PAGE_COMMON_API,
    params: params,
  });
};

export const postFaqEditPageCommonRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.GET_FAQ_EDIT_PAGE_COMMON_API,
    data: data,
  });
};
export const deleteFaqQuestionAndMappingRepo = (params) => {
  return axios({
    method: "DELETE",
    url: Urls.DELETE_QUESTION_AND_MAPPING_API,
    params: params,
  });
};

// AI FAQ EXAM PANEL
export const getFaqExamFilterRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.FAQ_EXAM_FILTER_API,
    params: params,
  });
};

export const getFaqExamListRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.FAQ_EXAM_LIST_API,
    params: params,
  });
};

export const getFaqCollegeFacetListRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls. FAQ_COLLEGE_FACET_LIST_API,
    params: params,
  });
};

export const getFaqCollegeFacetFilterRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls. FAQ_COLLEGE_FACET_FILTER_API,
    params: params,
  });
};

export const postFaqGenerateCommonRepo = (data, signal) => {
  return axios({
    method: "POST",
    url: Urls.FAQ_GENERATE_COMMON_API,
    data: data,
    timeout: 300000,
    signal,
  });
};
export const postFaqEntityLockRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.FAQ_ENTITY_LOCK_API,
    data: data,
  });
};
export const getFaqCollegeFilterRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls. FAQ_COLLEGE_FILTER_API,
    params: params,
  });
};
export const getFaqCollegeListRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls. FAQ_COLLEGE_LIST_API,
    params: params,
  });
};

export const postClearCacheRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.POST_CLEAR_CACHE,
    data: data,
  });
};
